(function () {
  var STORAGE_KEY = 'eos_wishlist_v1';
  var EVENT_NAME = 'eos:wishlist-changed';

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: { items: items } }));
  }

  function has(id) {
    return read().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function add(product) {
    var items = read();
    if (!items.some(function (item) { return String(item.id) === String(product.id); })) {
      items.push(product);
      write(items);
    }
  }

  function remove(id) {
    var items = read().filter(function (item) {
      return String(item.id) !== String(id);
    });
    write(items);
  }

  function toggle(product) {
    if (has(product.id)) {
      remove(product.id);
      return false;
    }
    add(product);
    return true;
  }

  function count() {
    return read().length;
  }

  function updateBadges() {
    var n = count();
    document.querySelectorAll('[data-wishlist-badge]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function updateToggleButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var on = has(id);
      btn.classList.toggle('is-active', on);
      var textEl = btn.querySelector('[data-wishlist-text]');
      if (textEl) {
        textEl.textContent = on
          ? (btn.getAttribute('data-text-remove') || 'Vom Merkzettel entfernen')
          : (btn.getAttribute('data-text-add') || 'Zum Merkzettel hinzufügen');
      }
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderList() {
    var container = document.querySelector('[data-wishlist-list]');
    if (!container) return;
    var items = read();
    var emptyEl = document.querySelector('[data-wishlist-empty]');

    if (!items.length) {
      container.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    container.innerHTML = items.map(function (item) {
      var title = escapeHtml(item.title);
      var img = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + title + '" loading="lazy">'
        : '';
      var price = item.price ? '<div class="wishlist-card__price">' + escapeHtml(item.price) + '</div>' : '';

      return (
        '<div class="wishlist-card">' +
          '<a href="' + escapeHtml(item.url) + '" class="wishlist-card__link">' +
            '<div class="wishlist-card__image">' + img + '</div>' +
            '<div class="wishlist-card__info">' +
              '<h3 class="wishlist-card__title">' + title + '</h3>' +
              price +
            '</div>' +
          '</a>' +
          '<button type="button" class="wishlist-card__remove" data-wishlist-remove data-product-id="' + escapeHtml(item.id) + '" aria-label="Vom Merkzettel entfernen">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>'
      );
    }).join('');
  }

  document.addEventListener(EVENT_NAME, function () {
    updateBadges();
    updateToggleButtons();
    renderList();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateBadges();
    updateToggleButtons();
    renderList();

    document.body.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('[data-wishlist-toggle]');
      if (toggleBtn) {
        e.preventDefault();
        toggle({
          id: toggleBtn.getAttribute('data-product-id'),
          handle: toggleBtn.getAttribute('data-product-handle'),
          title: toggleBtn.getAttribute('data-product-title'),
          image: toggleBtn.getAttribute('data-product-image'),
          price: toggleBtn.getAttribute('data-product-price'),
          url: toggleBtn.getAttribute('data-product-url')
        });
        return;
      }

      var removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        e.preventDefault();
        remove(removeBtn.getAttribute('data-product-id'));
      }
    });
  });

  window.EosWishlist = {
    read: read,
    add: add,
    remove: remove,
    toggle: toggle,
    has: has,
    count: count,
    updateBadges: updateBadges,
    updateToggleButtons: updateToggleButtons,
    renderList: renderList
  };
})();
